// Polyfill for findDOMNode which was removed in React 19
import ReactDOM from 'react-dom';

// Add findDOMNode back to ReactDOM for compatibility with older packages
if (!ReactDOM.findDOMNode) {
  ReactDOM.findDOMNode = function(componentOrElement) {
    if (componentOrElement == null) {
      return null;
    }
    
    if (componentOrElement.nodeType === 1) {
      return componentOrElement;
    }
    
    // For React components, try to find the DOM node
    if (componentOrElement._reactInternalFiber) {
      let fiber = componentOrElement._reactInternalFiber;
      while (fiber) {
        if (fiber.stateNode && fiber.stateNode.nodeType === 1) {
          return fiber.stateNode;
        }
        fiber = fiber.child;
      }
    }
    
    // Fallback - return null
    return null;
  };
}
